import {
    CREATE_SJFROLES,
    RETRIEVE_SJFROLES,
    RETRIEVESINGLE_SJFROLES,
    UPDATE_SJFROLES,
    DELETE_SJFROLES,
  } from "../actions/type";
  const initialState = [];
  function SJFRolesReducer(state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
      case CREATE_SJFROLES:
        return {data: state.data, payload};
      case RETRIEVE_SJFROLES:
        state = (payload.error == 1)?initialState:payload;
        return {data: state, payload};
      case RETRIEVESINGLE_SJFROLES:
        state = (payload.error == 1)?initialState:payload;
        return {data: state.data, payload};
      case UPDATE_SJFROLES:
        return {data: state.data, payload};
      case DELETE_SJFROLES:
        return {data: state.data, payload};
      default:
        return state;
    }
  };
  export {SJFRolesReducer};